import DASHBOARD_ROUTES from '../../routes';

export default {
    START: DASHBOARD_ROUTES.RESULTS,
    VIEW: (surveyId: number | string) =>
        `${DASHBOARD_ROUTES.RESULTS}/view/${surveyId}`,
};
